export const TOKENS_CONTRACTS = {
  usdt: {
    ethereum: "0xdac17f958d2ee523a2206206994597c13d831ec7",
    avalanche: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
    solana: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    tron: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
  },
  usdc: {
    ethereum: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    stellar: "USDC-GA5ZSEJYB37JRC5AVCIA5MOP4RHTM335X2KGX3IHOJAPP5RE34K4KZVN",
    base: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    solana: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    polygon: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    optimism: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    tron: "TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8",
  },
  dai: {
    ethereum: "0x6b175474e89094c44da98b954eedeac495271d0f",
  },
  pyusd: {
    ethereum: "0x6c3ea9036406852006290770bedfcaba0e23a0e8",
    solana: "2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo",
  },
};

export const TOKENS_CHAIN_ID = {
  ethereum: 1,
  avalanche: 43114,
  solana: 101,
  tron: 728126428,
  // stellar: "7",
  base: 8453,
  polygon: 137,
  optimism: 10,
};

export const TOKENS_PRECISION = {
  usdt: 6,
  usdc: 6,
  dai: 18,
  pyusd: 18,
};
